import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";
import React, { useContext, useEffect, useState } from "react";
import { format, parse, set } from "date-fns";
import { Button } from "primereact/button";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../../store/ui-context";
import { TabView, TabPanel } from "primereact/tabview";
import CustomerSelectorDialog from "../../../../dialogs/selectors/CustomerSelectorDialog";
import ListFreeProduct from "./ListFreeProduct";
import ProfileData from "./ProfileData";
import PointHistory from "./PointHistory";
import SalesHistory from "./SalesHistory";
import PackageHistory from "./PackageHistory";
import FreeProductEditorDialog from "./FreeProductEditorDialog";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useParams } from "react-router-dom";
import RewardHistory from "./RewardHistory";
import CheckInOutHistory from "./CheckInOutHistory";
import ListVoucher from "./ListVoucher";
import ListDiscount from "./ListDiscount";
import useIsMobile from "../../../../hooks/useIsMobile";
import DiscountEditorDialog from "./DiscountEditorDialog";
import VoucherEditorDialog from "./VoucherEditorDialog";

const title = "Customer Data";

const CustomerDataPage = (props) => {
  let { id } = useParams();
  const uiContext = useContext(UiContext);
  const dispatch = useDispatch();

  const isMobile = useIsMobile();

  const [visibleCustomerSelector, setVisibleCustomerSelector] = useState(false);
  const [visibleFreeProductEditor, setVisibleFreeProductEditor] = useState(false);
  const [visibleVoucherEditor, setVisibleVoucherEditor] = useState(false);
  const [visibleDiscountEditor, setVisibleDiscountEditor] = useState(false);
  const [freeProductEditorData, setFreeProductEditorData] = useState(null);
  const [voucherEditorData, setVoucherEditorData] = useState(null);
  const [discountEditorData, setDiscountEditorData] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [listVoucher, setListVoucher] = useState([]);
  const [listDiscount, setListDiscount] = useState([]);
  const [listFreeProduct, setListFreeProduct] = useState([]);
  const [listPointHistory, setListPointHistory] = useState([]);
  const [listSalesHistory, setListSalesHistory] = useState([]);
  const [listFreeProductHistory, setListFreeProductHistory] = useState([]);
  const [listCheckInOutHistory, setListCheckInOutHistory] = useState([]);

  const { requestPost, requestDelete, requestGetOne, loading, requestGet } =
    useAPIRequest();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  useEffect(() => {
    if (id && id > 0) {
      loadCustomer(id);
    }
  }, [id]);

  const loadCustomer = (id) => {
    if (id > 0) {
      requestGetOne({
        fullUrl: `api/customer/customer/one/${id}`,
        onSuccess: ({ message, data }) => {
          setSelectedCustomer(data);
        },
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
      });
    }
  };

  const handleOnChangeCustomer = (newCustomer) => {
    // console.log("DATA", newCustomer);
    setSelectedCustomer(newCustomer);
    setListFreeProduct([]);
    setListVoucher([]);
    setListDiscount([]);
    setListPointHistory([]);
    setListSalesHistory([]);
    setListFreeProductHistory([]);
  };

  const handleLoading = () => {
    handleLoadFreeProducts({ showExpired: false });
    handleLoadVoucher({ showExpired: false });
    handleLoadDiscount({ showExpired: false });
  };

  const handleLoadFreeProducts = async ({ showExpired }) => {
    setListFreeProduct([]);
    if (selectedCustomer && selectedCustomer.id) {
      const id = selectedCustomer.id;
      const expiredTxt = format(new Date(), "yyyy-MM-dd");
      const res = await requestGet({
        fullUrl: "api/customer/customerfreeproduct/data",
        params: {
          page: 1,
          take: 1000,
          filter: `customer_id:=:${id}${showExpired ? "" : `;expired_date:>=:${expiredTxt}`
            };usage_date:=:Null`,
          with_product: 1,
        },
        onSuccess: ({ pagination, message, data }) => {
          // change field in list data, expired_date to Date object
          const newData = data.map((item) => {
            return {
              ...item,
              expired_date: parse(item.expired_date, "yyyy-MM-dd", new Date()),
            };
          });
          // sort newData by data_product.name ASC on first level and expired_date ASC on second level
          newData.sort((a, b) => {
            if (a.data_product.name < b.data_product.name) {
              return -1;
            }
            if (a.data_product.name > b.data_product.name) {
              return 1;
            }
            if (a.expired_date < b.expired_date) {
              return -1;
            }
            if (a.expired_date > b.expired_date) {
              return 1;
            }
            return 0;
          });

          setListFreeProduct(newData);
        },
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
      });
    }
  };

  const handleLoadVoucher = async ({ showExpired }) => {
    setListVoucher([]);
    if (selectedCustomer && selectedCustomer.id) {
      const id = selectedCustomer.id;
      const expiredTxt = format(new Date(), "yyyy-MM-dd");
      const res = await requestGet({
        fullUrl: "api/customer/customervoucher/data",
        params: {
          page: 1,
          take: 1000,
          filter: `customer_id:=:${id}${showExpired ? "" : `;expired_date:>=:${expiredTxt}`
            };sales_payment_id:=:Null`,
          "with_customer,data_bc": 1,
          "with_sales_payment,data_sales": 1,
        },
        onSuccess: ({ pagination, message, data }) => {
          // change field in list data, expired_date to Date object
          const newData = data.map((item) => {
            return {
              ...item,
              expired_date: parse(item.expired_date, "yyyy-MM-dd", new Date()),
            };
          });
          // sort newData by data_product.name ASC on first level and expired_date ASC on second level
          newData.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            if (a.expired_date < b.expired_date) {
              return -1;
            }
            if (a.expired_date > b.expired_date) {
              return 1;
            }
            return 0;
          });

          setListVoucher(newData);
        },
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
      });
    }
  };

  const handleLoadDiscount = async ({ showExpired }) => {
    setListDiscount([]);
    if (selectedCustomer && selectedCustomer.id) {
      const id = selectedCustomer.id;
      const expiredTxt = format(new Date(), "yyyy-MM-dd");
      const res = await requestGet({
        fullUrl: "api/customer/customerdiscount/data",
        params: {
          page: 1,
          take: 1000,
          filter: `customer_id:=:${id}${showExpired ? "" : `;expired_date:>=:${expiredTxt}`
            };sales_discount_id:=:Null`,
          "with_customer,data_bc": 1,
          "with_sales_discount,data_sales": 1,
        },
        onSuccess: ({ pagination, message, data }) => {
          // change field in list data, expired_date to Date object
          const newData = data.map((item) => {
            return {
              ...item,
              expired_date: parse(item.expired_date, "yyyy-MM-dd", new Date()),
            };
          });
          // sort newData by data_product.name ASC on first level and expired_date ASC on second level
          newData.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            if (a.expired_date < b.expired_date) {
              return -1;
            }
            if (a.expired_date > b.expired_date) {
              return 1;
            }
            return 0;
          });

          setListDiscount(newData);
        },
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
      });
    }
  };

  const handleLoadPointHistory = async ({ fromDate, toDate }) => {
    setListPointHistory([]);
    if (selectedCustomer && selectedCustomer.id) {
      const filter = `customer_id:=:${selectedCustomer.id
        };transaction_date:>=:${format(
          fromDate,
          "yyyy-MM-dd"
        )};transaction_date:<=:${format(toDate, "yyyy-MM-dd")}`;
      const res = await requestGet({
        fullUrl: "api/customer/pointtransactionhistory/data",
        params: {
          page: 1,
          take: 1000,
          filter,
          order: "transaction_date",
          order_method: "DESC",
        },
        onSuccess: ({ pagination, message, data }) => {
          setListPointHistory(data);
        },
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
      });
    }
  };

  const handleLoadSalesHistory = async ({ fromDate, toDate }) => {
    setListSalesHistory([]);
    if (selectedCustomer && selectedCustomer.id) {
      const filter = `data_sales.customer_id:=:${selectedCustomer.id
        };data_sales.transaction_date:>=:${format(
          fromDate,
          "yyyy-MM-dd"
        )};data_sales.transaction_date:<=:${format(toDate, "yyyy-MM-dd")}`;

      const res = await requestGet({
        fullUrl: "api/sales/salesitem/data",
        params: {
          page: 1,
          take: 1000,
          filter,
          order: "created_at",
          order_method: "DESC",
          with_sales: 1,
          with_product: 1,
          with_doctor: 1,
          with_nurse_1: 1,
          with_nurse_2: 1,
          with_nurse_3: 1,
          with_therapist_1: 1,
          with_therapist_2: 1,
          with_therapist_3: 1,
        },
        onSuccess: ({ pagination, message, data }) => {
          // sort data by data_sales.transaction_date DESC
          data.sort((a, b) => {
            if (a.data_sales.transaction_date < b.data_sales.transaction_date) {
              return 1;
            }
            if (a.data_sales.transaction_date > b.data_sales.transaction_date) {
              return -1;
            }
            return 0;
          });
          setListSalesHistory(data);
        },
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
      });
    }
  };

  const handleLoadPackageHistory = async ({ fromDate, toDate }) => {
    setListFreeProductHistory([]);
    if (selectedCustomer && selectedCustomer.id) {
      let filter = "";
      if (fromDate && toDate) {
        filter = `customer_id:=:${selectedCustomer.id
          };data_source_sales_item.data_sales.transaction_date:>=:${format(
            fromDate,
            "yyyy-MM-dd"
          )};data_source_sales_item.data_sales.transaction_date:<=:${format(
            toDate,
            "yyyy-MM-dd"
          )}`;
      } else {
        filter = `customer_id:=:${selectedCustomer.id}`;
      }
      const res = await requestGet({
        fullUrl: "api/customer/customerfreeproduct/data",
        params: {
          page: 1,
          take: 1000,
          filter,
          order: "created_at",
          order_method: "DESC",
          with_source_sales_item: 1,
          with_product: 1,
          with_usage_sales_item: 1,
        },
        onSuccess: ({ pagination, message, data }) => {
          const newData = sortData(data);
          setListFreeProductHistory(newData);
        },
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
      });
    }
  };

  const handleLoadCheckInOutHistory = async ({ fromDate, toDate }) => {
    setListCheckInOutHistory([]);
    if (selectedCustomer && selectedCustomer.id) {
      let filter = "";
      if (fromDate && toDate) {
        filter = `customer_id:=:${selectedCustomer.id
          };transaction_date:>=:${format(
            fromDate,
            "yyyy-MM-dd"
          )};transaction_date:<=:${format(toDate, "yyyy-MM-dd")}`;
      } else {
        filter = `customer_id:=:${selectedCustomer.id}`;
      }
      const res = await requestGet({
        fullUrl: "api/sales/sales/data",
        params: {
          page: 1,
          take: 1000,
          filter,
          order: "transaction_date",
          order_method: "DESC",
        },
        onSuccess: ({ pagination, message, data }) => {
          const newList = data.map((item, index) => {
            const duration =
              item.check_in && item.check_out
                ? (new Date(item.check_out).getTime() -
                  new Date(item.check_in).getTime()) /
                (1000 * 60)
                : undefined;
            let durationTxt = "";
            if (duration && duration > 0) {
              const hours = Math.floor(duration / 60);
              const minutes = Math.floor(duration % 60);
              durationTxt = `${hours.toLocaleString(
                "id-ID"
              )} H : ${minutes.toLocaleString("id-ID")} M`;
            }

            return {
              id: index,
              transaction_date: item.transaction_date,
              check_in: item.check_in,
              check_out: item.check_out,
              sales_number: item.number,
              with_appointment: item.crm_schedule_customer_id ? "Yes" : "",
              duration: durationTxt,
            };
          });

          setListCheckInOutHistory(newList);
        },
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
      });
    }
  };

  const sortData = (data) => {
    // if data_source_sales_item.data_sales.transaction_date exist,
    // sort by data_source_sales_item.data_sales.transaction_date DESC on first level, and expired_date DESC on second level
    // else sort by created_at DESC on first level, and expired_date DESC on second level
    return data.sort((a, b) => {
      if (
        a.data_source_sales_item &&
        b.data_source_sales_item &&
        a.data_source_sales_item.data_sales &&
        b.data_source_sales_item.data_sales
      ) {
        if (
          a.data_source_sales_item.data_sales.transaction_date <
          b.data_source_sales_item.data_sales.transaction_date
        ) {
          return 1;
        }
        if (
          a.data_source_sales_item.data_sales.transaction_date >
          b.data_source_sales_item.data_sales.transaction_date
        ) {
          return -1;
        }
      }
      if (a.created_at < b.created_at) {
        return 1;
      }
      if (a.created_at > b.created_at) {
        return -1;
      }
      if (a.expired_date < b.expired_date) {
        return 1;
      }
      if (a.expired_date > b.expired_date) {
        return -1;
      }
      return 0;
    });
  };

  const handleEditFreeProductProcedure = (data) => {
    setFreeProductEditorData(data);
    setVisibleFreeProductEditor(true);
  };

  const handleEditVoucherProcedure = (data) => {
    setVoucherEditorData(data);
    console.log("edit voucher data", data);
    setVisibleVoucherEditor(true);
  };

  const handleEditDiscountProcedure = (data) => {
    console.log("edit discount data", data);
    setDiscountEditorData(data);
    setVisibleDiscountEditor(true);
  };

  const handleAddFreeProductProcedure = () => {
    setFreeProductEditorData(null);
    setVisibleFreeProductEditor(true);
  };
  const handleAddVoucherProcedure = () => {
    setVoucherEditorData(null);
    setVisibleVoucherEditor(true);
  };
  const handleAddDiscountProcedure = () => {
    setDiscountEditorData(null);
    setVisibleDiscountEditor(true);
  };

  const handleSaveFreeProduct = async (data) => {
    const body = {
      customer_id: selectedCustomer.id,
      product_id: data.data_product.id,
      quantity: data.quantity,
      expired_date: format(data.expired_date, "yyyy-MM-dd"),
      request_expired_date: data.request_expired_date
        ? format(data.request_expired_date, "yyyy-MM-dd")
        : null,
      description: data.description,
      type: data.type ?? 1,
    };
    if (data.id && data.id > 0) {
      body["id"] = data.id;
    }

    return requestPost({
      fullUrl: "api/customer/customerfreeproduct/save",
      body,
      onSuccess: ({ pagination, message, data }) => {
        // convert expired date to Date object
        data.expired_date = parse(data.expired_date, "yyyy-MM-dd", new Date());
        uiContext.showSuccessMsg("Success", message);
        setVisibleFreeProductEditor(false);
        // check if data already exist by comparing id
        const index = listFreeProduct.findIndex((item) => item.id === data.id);
        if (index >= 0) {
          const newList = [...listFreeProduct];
          newList[index] = data;
          setListFreeProduct(newList);
        } else {
          setListFreeProduct([data, ...listFreeProduct]);
        }
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  const handleRemoveFreeProduct = async (data) => {
    const idToDelete = data.id;
    return await requestDelete({
      fullUrl: "api/customer/customerfreeproduct/delete",
      ids: [idToDelete],
      onSuccess: ({ data }) => {
        uiContext.showSuccessMsg(
          "Success",
          "Free product removed successfully"
        );
        setVisibleFreeProductEditor(false);
        // remove from listFreeProduct where id is equal to data.id
        const newList = listFreeProduct.filter(
          (item) => item.id !== idToDelete
        );
        setListFreeProduct(newList);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const handleRemoveFreeProductProcedure = (data) => {
    confirmDialog({
      acceptClassName: "p-button-danger",
      message: "You are about to remove this free product, continue?",
      header: "Remove",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        handleRemoveFreeProduct(data);
      },
    });
  };

  const handleSaveVoucher = async (data) => {
    const body = {
      customer_id: selectedCustomer.id,
      name: data.name,
      amount: data.amount,
      expired_date: format(data.expired_date, "yyyy-MM-dd"),
      description: data.description,
    };
    if (data.id && data.id > 0) {
      body["id"] = data.id;
    }

    return requestPost({
      fullUrl: "api/customer/customervoucher/save",
      body,
      onSuccess: ({ pagination, message, data }) => {
        // convert expired date to Date object
        data.expired_date = parse(data.expired_date, "yyyy-MM-dd", new Date());
        uiContext.showSuccessMsg("Success", message);
        setVisibleVoucherEditor(false);
        // check if data already exist by comparing id
        const index = listVoucher.findIndex((item) => item.id === data.id);
        if (index >= 0) {
          const newList = [...listVoucher];
          newList[index] = data;
          setListVoucher(newList);
        } else {
          setListVoucher([data, ...listVoucher]);
        }
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  const handleRemoveVoucher = async (data) => {
    const idToDelete = data.id;
    return await requestDelete({
      fullUrl: "api/customer/customervoucher/delete",
      ids: [idToDelete],
      onSuccess: ({ data }) => {
        uiContext.showSuccessMsg(
          "Success",
          "Voucher removed successfully"
        );
        setVisibleVoucherEditor(false);
        // remove from listVoucher where id is equal to data.id
        const newList = listVoucher.filter(
          (item) => item.id !== idToDelete
        );
        setListVoucher(newList);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const handleRemoveVoucherProcedure = (data) => {
    confirmDialog({
      acceptClassName: "p-button-danger",
      message: "You are about to remove this voucher, continue?",
      header: "Remove",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        handleRemoveVoucher(data);
      },
    });
  };

  const handleSaveDiscount = async (data) => {
    const body = {
      customer_id: selectedCustomer.id,
      name: data.name,
      value: data.value,
      type: data.type,
      expired_date: format(data.expired_date, "yyyy-MM-dd"),
      description: data.description,
    };
    if (data.id && data.id > 0) {
      body["id"] = data.id;
    }

    return requestPost({
      fullUrl: "api/customer/customerdiscount/save",
      body,
      onSuccess: ({ pagination, message, data }) => {
        // convert expired date to Date object
        data.expired_date = parse(data.expired_date, "yyyy-MM-dd", new Date());
        uiContext.showSuccessMsg("Success", message);
        setVisibleDiscountEditor(false);
        // check if data already exist by comparing id
        const index = listDiscount.findIndex((item) => item.id === data.id);
        if (index >= 0) {
          const newList = [...listDiscount];
          newList[index] = data;
          setListDiscount(newList);
        } else {
          setListDiscount([data, ...listDiscount]);
        }
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  const handleRemoveDiscount = async (data) => {
    const idToDelete = data.id;
    return await requestDelete({
      fullUrl: "api/customer/customerdiscount/delete",
      ids: [idToDelete],
      onSuccess: ({ data }) => {
        uiContext.showSuccessMsg(
          "Success",
          "Discount removed successfully"
        );
        setVisibleDiscountEditor(false);
        // remove from listDiscount where id is equal to data.id
        const newList = listDiscount.filter(
          (item) => item.id !== idToDelete
        );
        setListDiscount(newList);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const handleRemoveDiscountProcedure = (data) => {
    confirmDialog({
      acceptClassName: "p-button-danger",
      message: "You are about to remove this discount, continue?",
      header: "Remove",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        handleRemoveDiscount(data);
      },
    });
  };

  return (
    <div className={`col-start-start px-4 gap-4 w-100`}>
      <ConfirmDialog />
      <CustomerSelectorDialog
        visible={visibleCustomerSelector}
        onHide={() => {
          setVisibleCustomerSelector(false);
        }}
        onConfirm={(e, data) => {
          if (data && data.length > 0) {
            handleOnChangeCustomer(data[0]);
            setVisibleCustomerSelector(false);
          }
        }}
      />
      <FreeProductEditorDialog
        visible={visibleFreeProductEditor}
        onHide={() => {
          setVisibleFreeProductEditor(false);
        }}
        loading={loading}
        data={freeProductEditorData}
        onConfirm={handleSaveFreeProduct}
        onRemove={handleRemoveFreeProductProcedure}
      />
      <DiscountEditorDialog
        visible={visibleDiscountEditor}
        onHide={() => {
          setVisibleDiscountEditor(false);
        }}
        loading={loading}
        data={discountEditorData}
        onConfirm={handleSaveDiscount}
        onRemove={handleRemoveDiscountProcedure}
      />
      <VoucherEditorDialog
        visible={visibleVoucherEditor}
        onHide={() => {
          setVisibleVoucherEditor(false);
        }}
        loading={loading}
        data={voucherEditorData}
        onConfirm={handleSaveVoucher}
        onRemove={handleRemoveVoucherProcedure}
      />
      <div></div>
      <div className="elevated-card-tight-vertical col-start-start w-full gap-4">
        <div className="row-start-center w-full gap-4">
          <Button
            icon="pi pi-search"
            label="Change"
            loading={loading}
            onClick={(e) => {
              e.preventDefault();
              setVisibleCustomerSelector(true);
            }}
          />
          {selectedCustomer && selectedCustomer.code && (
            <div className="row-start-center gap-1">
              <i className="pi pi-hashtag  text-slate-500" />
              <span className="font-semibold text-lg text-slate-500">
                {selectedCustomer ? `(${selectedCustomer.code})` : ""}
              </span>
            </div>
          )}
          <span className="font-semibold text-lg text-slate-500">
            {selectedCustomer ? selectedCustomer.name : "-"}
          </span>
        </div>
        <ProfileData data={selectedCustomer} />
      </div>
      {isMobile ? (
        <>
          <div className="col-start-start gap-4 w-full">
            <div className="elevated-card-tight-vertical col-start-start gap-4 w-full">
              <ListFreeProduct
                title={"REWARD & REDEEM"}
                data={listFreeProduct.filter((item) => item.type !== 2)}
                loading={loading}
                onLoad={() => handleLoadFreeProducts({ showExpired: false })}
                onLoadAll={() => handleLoading()}
                onAdd={handleAddFreeProductProcedure}
                onEdit={handleEditFreeProductProcedure}
              />
            </div>
            <div className="elevated-card-tight-vertical col-start-start gap-4 w-full">
              <ListFreeProduct
                title={"CUSTOMER PACKAGE"}
                data={listFreeProduct.filter((item) => item.type === 2)}
                loading={loading}
                onLoad={() => handleLoadFreeProducts({ showExpired: false })}
                onLoadAll={() => handleLoading()}
                // onAdd={handleAddFreeProductProcedure}
                onEdit={handleEditFreeProductProcedure}
              />
            </div>
            <div className="elevated-card-tight-vertical col-start-start gap-4 w-full">
              <ListVoucher
                title={"VOUCHER"}
                data={listVoucher}
                loading={loading}
                onLoad={() => handleLoadVoucher({ showExpired: false })}
                onLoadAll={() => handleLoading()}
                // onAdd={handleAddVoucherProcedure}
                onEdit={handleEditVoucherProcedure}
              />
            </div>
            <div className="elevated-card-tight-vertical col-start-start gap-4 w-full">
              <ListDiscount
                title={"DISCOUNT"}
                data={listDiscount}
                loading={loading}
                onLoad={() => handleLoadDiscount({ showExpired: false })}
                onLoadAll={() => handleLoading()}
                // onAdd={handleAddDiscountProcedure}
                onEdit={handleEditDiscountProcedure}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="row-start-start gap-4 w-full">
            <div className="elevated-card-tight-vertical col-start-start gap-4 w-full">
              <ListFreeProduct
                title={"REWARD & REDEEM"}
                data={listFreeProduct.filter((item) => item.type !== 2)}
                loading={loading}
                onLoad={() => handleLoadFreeProducts({ showExpired: false })}
                onLoadAll={() => handleLoading()}
                onAdd={handleAddFreeProductProcedure}
                onEdit={handleEditFreeProductProcedure}
              />
            </div>
            <div className="elevated-card-tight-vertical col-start-start gap-4 w-full">
              <ListFreeProduct
                title={"CUSTOMER PACKAGE"}
                data={listFreeProduct.filter((item) => item.type === 2)}
                loading={loading}
                onLoad={() => handleLoadFreeProducts({ showExpired: false })}
                onLoadAll={() => handleLoading()}
                // onAdd={handleAddFreeProductProcedure}
                onEdit={handleEditFreeProductProcedure}
              />
            </div>
          </div>
          <div className="row-start-start gap-4 w-full">
            <div className="elevated-card-tight-vertical col-start-start gap-4 w-full">
              <ListVoucher
                title={"VOUCHER"}
                data={listVoucher}
                loading={loading}
                onLoad={() => handleLoadVoucher({ showExpired: false })}
                onLoadAll={() => handleLoading()}
                // onAdd={handleAddVoucherProcedure}
                onEdit={handleEditVoucherProcedure}
              />
            </div>
            <div className="elevated-card-tight-vertical col-start-start gap-4 w-full">
              <ListDiscount
                title={"DISCOUNT"}
                data={listDiscount}
                loading={loading}
                onLoad={() => handleLoadDiscount({ showExpired: false })}
                onLoadAll={() => handleLoading()}
                // onAdd={handleAddDiscountProcedure}
                onEdit={handleEditDiscountProcedure}
              />
            </div>
          </div>
        </>
      )}
      <div className="elevated-card-tight-vertical row-start-start w-full">
        <TabView className="w-full">
          <TabPanel leftIcon="pi pi-history mr-2" header="Point History">
            <PointHistory
              data={listPointHistory}
              onLoad={handleLoadPointHistory}
              loading={loading}
            />
          </TabPanel>
          <TabPanel leftIcon="pi pi-history mr-2" header="Sales History">
            <SalesHistory
              data={listSalesHistory}
              onLoad={handleLoadSalesHistory}
              loading={loading}
            />
          </TabPanel>
          <TabPanel leftIcon="pi pi-history mr-2" header="Package History">
            <PackageHistory
              data={listFreeProductHistory.filter((item) => item.type === 2)}
              onLoad={handleLoadPackageHistory}
              loading={loading}
            />
          </TabPanel>
          <TabPanel leftIcon="pi pi-history mr-2" header="Reward History">
            <RewardHistory
              data={listFreeProductHistory.filter((item) => item.type !== 2)}
              onLoad={handleLoadPackageHistory}
              loading={loading}
            />
          </TabPanel>
          <TabPanel leftIcon="pi pi-history mr-2" header="Check In/Out History">
            <CheckInOutHistory
              data={listCheckInOutHistory}
              onLoad={handleLoadCheckInOutHistory}
              loading={loading}
            />
          </TabPanel>
        </TabView>
      </div>
      <div></div>
    </div>
  );
};

export default CustomerDataPage;
